<template>
  <div class="cls-generic-filter">
    <div
      class="cls-generic-filter-select"
      v-clickout="
        () => {
          visible = false;
          search = '';
        }
      "
      :class="{ active: visible }"
    >
      <div
        class="selected-item"
        @click="visible = !visible"
        :style="{
          width: width,
          border: '0.0625em solid rgba(255, 255, 255, 0.3)'
        }"
        v-bind:class="{
          'selected-item-applied':
            showIsFilterApplied && selectedData.length > 0,
          classArray
        }"
      >
        <div class="selected-item-text">
          {{
            showIsFilterApplied && selectedData.length > 0
              ? `${selectedData.length} ${$t('filteresApplied')}`
              : name
          }}
        </div>

        <button
          class="btn-"
          :style="
            `transform: rotate(${visible ? 180 : 0}deg)
            transform: translateY(2px);
          `
          "
        >
          <BaseIcon
            name="arrowDown"
            class="test"
            height="0.8rem"
            width="0.8rem"
          />
        </button>
      </div>
      <div class="filter" v-show="visible">
        <div
          class="option-wrapper"
          v-for="(node, index1) in data"
          :key="index1"
        >
          <div class="filter-level">
            <span class="level-name">
              {{ node.name }}
            </span>
          </div>

          <div class="option" v-for="(i, index) in node.item" :key="index">
            <div class="option-icon" @click="dataSelectHandler(i, index1)">
              <div class="filter-selected-icon">
                <BaseIcon
                  :name="multiSelectIcon"
                  v-if="checkForSelected(i, node.name)"
                />
              </div>
              <div class="filter-selected-content">
                <span v-if="i.iconName">
                  <base-icon :name="i.iconName" width="1.5em" height="1.5em" />
                </span>

                <span
                  class="filter-item-name"
                  :style="i.styling ? i.styling : ''"
                >
                  {{ i.name }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="clear-filter"
      v-if="selectedData.length > 0"
      @click="clearFilter"
    >
      {{ $t('clearFilter') }}
    </div>
  </div>
</template>

<script>
/**
 * The only true select dropdown .
 * @displayName RexGenericFilter
 */
export default {
  components: {},
  name: 'RexGenericFilter',
  props: {
    /**
     * The data to be passed on the select
     * The data format will be of array of objects
     * @example [{"name":"Type","item":[{"name":"Debug","iconName":"debug"},{"name":"Navigation","iconName":"navigation"},{"name":"User Action","iconName":"userAction"},{"name":"Error","iconName":"errorFilter"}]},{"name":"Level","item":[{"name":"Warning","styling":{"color":"rgb(250 ,125 ,0)"}},{"name":"Info","styling":{"color":"rgb(31 ,136 ,219)"}},{"name":"Error","styling":{"color":"rgb(248,48,35)"}}]}]
     */
    data: { type: Array },
    /**
     * The width of the dropdown
     *
     */
    width: { type: String, default: '20.75em' },
    /**
     * name to be displayed on the select
     * @example <caption>Select Filters</caption>
     *
     */
    name: { type: String },
    /**
     * Display the no of filtered applied
     *
     */
    showIsFilterApplied: { type: Boolean, default: true },
    /**
     * objectValueIndex is the index of the values that to be showed when there are muliple key value pairs in the object
     *
     *
     */
    objectValueIndex: {},

    /**
     * multiSelectIcon is for the custom icon for multiselect
     *
     */
    multiSelectIcon: { type: String, default: 'check' },
    /**
     * icons conatins the array with the following definition which cabn be used for actions such as edit or delete
     * @example
     * [
        {
          emitName: 'Edit',
          iconName: 'editFilled',
          width: '1em',
          height: '1em'
        },
        {
          emitName: 'Delete',
          iconName: 'deleteFilled',
          width: '1em',
          height: '1em'
        }
      ]
     */
    icons: {
      type: Array,
      default: () => [
        {
          emitName: 'Edit',
          iconName: 'editFilled',
          width: '1em',
          height: '1em'
        },
        {
          emitName: 'Delete',
          iconName: 'deleteFilled',
          width: '1em',
          height: '1em'
        }
      ]
    },

    classArray: { type: Array, default: () => [] }
  },
  data: function() {
    return {
      search: '',
      visible: false,
      selectedData: []
    };
  },

  methods: {
    /**
     * Gets called whenver the user selects the data from the dropdown
     *
     * @param {object} item selected object
     * @param {Number} index the index of the data array
     */
    dataSelectHandler(item, index) {
      let selItem = Object.create(null);
      selItem = {
        node: this.data[index].name,
        value: item.name
      };
      const found = this.selectedData.some(
        el => el.value === selItem.value && el.node === selItem.node
      );
      if (!found) this.selectedData.push(selItem);
      else {
        const removeIndex = this.selectedData.findIndex(
          el => el.value === selItem.value && el.node === selItem.node
        );
        // remove object
        this.selectedData.splice(removeIndex, 1);
      }
      this.inputEventDataHandler();
    },
    checkForSelected(item, node) {
      const found = this.selectedData.some(
        el => el.value === item.name && el.node === node
      );
      if (!found) return false;
      else return true;
    },
    /**
     * input event.
     *
     * @fires input
     * @event inputEventDataHandler#input
     * @type {Array}
     */
    inputEventDataHandler() {
      /**
       * triggered when slected filters are updated, selected filters are sent as array of objects
       * @property {array}
       * @event input
       */
      this.$emit('input', this.selectedData);
    },
    /**
     * Gets called when the selected data neeeds to be reset
     *
     */
    clearFilter() {
      this.selectedData = [];
      this.inputEventDataHandler();
    }
  },
  computed: {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.cls-generic-filter {
  @include flex-center-justify(flex-start);
}
.heading {
  @include heading-text;
  margin-right: 0.5625rem;
}
.cls-generic-filter-select {
  position: relative;
  border-radius: 0.1875rem;
  height: 2.5rem;
  .icon {
    flex-shrink: 0;
  }
  .selected {
    display: inline-block;
    padding: 0.3125rem;
    border-radius: 0.1875rem;
    margin: 0.1875rem;
    overflow: hidden;
  }
  .remove-icon {
    display: inline-block;
    margin-left: 0.3125rem;
    cursor: pointer;
  }
}
.active {
  @include active-state;
}
.filter-selected-content {
  width: 11.313em;
  margin-left: 0.4563rem;
}

.selected-item-text {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-all;
}
.selected-item {
  height: 100%;
  width: 100%;
  padding-left: 0.9375rem;
  overflow: auto;
  @include flex-center-justify;
  border-radius: 0.1875rem;
  color: $font-primary;
}
.filter {
  position: absolute;
  margin-top: 0.3125rem;
  width: 100%;
  top: 100%;
  left: 0;
  background: $bg-primary;
  border-radius: 0.375rem;
  border-right-width: 0.0625em !important;
  text-align: left;
  @include dropshadow-effect(0.33);
  z-index: 499;
  .close-btn {
    @include btn-fill($font-primary);
  }
}
.filter-level {
  background-color: $bg-secondary;
  height: 1.875rem;
  text-align: left;
  color: $font-primary;
}
.filter-item-name {
  margin-left: 2.125rem;
}
.level-name {
  margin-left: 2rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
}
.filter-selected-icon {
  margin-left: 0.65rem;
  width: 2.181rem;
}

.option {
  line-height: 2.25rem;
  margin: 0.125rem 0.125rem;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: $font-primary;

  &:hover {
    background-color: $color-brand-accent;
    color: $font-contrast;
    cursor: pointer;
  }

  .icon {
    margin-right: 1.125rem;
    fill: $font-primary;
    &:last-child {
      margin-right: 0px;
    }
  }
}
.option-icon {
  @include flex-center-justify(flex-start);
}

.option-wrapper {
  overflow: auto;
  padding-bottom: 0.125em;
}
.btn- {
  @include btn-fill($font-primary);
  padding: none;
  margin: 0px 0.275em;
}
.selected-item-applied {
  background-color: $font-primary;
  color: $bg-primary;
}
.filter-box {
  margin: 0.3125em;
  border-radius: 0.1875em;
  border: 0.0625em $color-brand-accent solid;
  display: flex;
  align-items: center;
}
.clear-filter {
  margin-right: 1.0625rem;
  margin-left: 1.25rem;
  text-decoration: underline;
  color: $color-brand-accent;
  cursor: pointer;
}
</style>
